import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Tour } from '../classes/tour';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TourService {
  private endpoint = environment.urlAPI + '/tour';

  constructor(private http: HttpClient) {}

  getTour(id: number) {
    return this.http.post<Tour>(this.endpoint, JSON.stringify({ id: id }));
  }
}
